export default "__VITE_ASSET__D39OOC6p__"